import api from "../pages/api/axios";

export const postLogin = async (data) => {
  const res = await api.post("/login", data);
  const r = res.data;

  return {
    status: r.status || 200,
    accessToken: r.accessToken,
    jwtInformation: {
      uid: r.uid || 1,
      role: r?.jwtInformation?.role,
      email: r?.jwtInformation?.email,
      accessToken: r.accessToken,
      userData: r.userData || r.jwtInformation,
    },
    requiresOtp: r.requiresOtp,
    roles: r.roles,
    message: r.message,
  };
};


export const postLogout = () => {
  return api.post("/logout").then((res) => res.data);
};

export const getLoggedInUser = () => {
  const user = localStorage.getItem("authUser");
  return user ? JSON.parse(user) : null;
};
